import axios from 'axios';
import SiteConfig from './positiva';
import { getAccessToken } from '../utils/auth';
import Repository from './Repository'

const CancelToken = axios.CancelToken;

const instance = axios.create({
    baseURL: SiteConfig.BASE_URL,
    timeout: 10000
});

const getSignedURL = (filename, contentType) => {
    return instance.post(`/quotation/s3-presigned`, {
            'filename': filename,
            'file_content_type': contentType
    },{
        headers: {
            'Authorization': 'Token ' + getAccessToken(),
        }
    })
}

const uploadFile = (data, file, cancelToken, onProgress) => {
    let formData = new FormData()

    let config = {
        cancelToken: cancelToken,
        onUploadProgress: function(e) {
            onProgress(Math.round((e.loaded * 100) / e.total ))
        }
    }

    formData.append('acl', 'private')
    formData.append('key', data.fields.key)
    formData.append('AWSAccessKeyId', data.fields.AWSAccessKeyId)
    formData.append('policy', data.fields.policy)
    formData.append('signature', data.fields.signature)
    formData.append('Content-Type', file.type)
    formData.append('file', file)

    return axios.post(data.url, formData, config)
}

const createCommentAttachment = async (filename, contentType) => {
    return await instance.post(`/quotation/comment-attachment/create/`, {
            'filename': filename,
            'file_content_type': contentType
    },{
        headers: {
            'Authorization': 'Token ' + getAccessToken(),
        }
    })
}

const createFieldAttachment = (filename, contentType) => {
  return instance.post(`/quotation/field-attachment/create/`, {
          'filename': filename,
          'file_content_type': contentType
  },{
      headers: {
          'Authorization': 'Token ' + getAccessToken(),
      }
  })
}

const getQuotationAttachement = (quotationfield_id) => Repository.private().get(`/quotation/attachment/${quotationfield_id}/`)
const getQuotationFieldAttachment = (quotationfieldAttachment_id) => Repository.private().get(`/quotation/field-attachment/${quotationfieldAttachment_id}/`)

const getQuotationCommentAttachement = (quotationcommentattachment_id) => Repository.private().get(`/quotation/comment-attachment/${quotationcommentattachment_id}/`)
export default {
    getSignedURL,
    uploadFile,
    CancelToken,
    createCommentAttachment,
    createFieldAttachment,
    getQuotationAttachement,
    getQuotationCommentAttachement,
    getQuotationFieldAttachment
}
